import { Accordion, Form } from "react-bootstrap";
import ReactSlider from "react-slider";
import BasemapPicker from "../../form/basemapPicker";
import enums from "../../../utilities/enums";

export default function SettingsToolbox(props) {
   
    const onBasemapChange = function (value) {
        if (props.onBasemapChange) {
            props.onBasemapChange(value);
        }
    }

    const onPrintBasemapChange = function (value) {
        if (props.onPrintBasemapChange) {
            props.onPrintBasemapChange(value);
        }
    }

    const onSnappingToleranceChange = function (e) {
        if (props.onSnappingToleranceChange) {
            props.onSnappingToleranceChange(e);
        }
    }

    const onArrowScaleChange = function(e) {
        if (props.onArrowScaleChange) {
            props.onArrowScaleChange(e);
        }
    }

    const onAfterArrowScaleChange = function(e) {
        if (props.onAfterArrowScaleChange) {
            props.onAfterArrowScaleChange(e);
        }
    }

    const onSymbolScaleChange = function (e) {
        if (props.onSymbolScaleChange) {
            props.onSymbolScaleChange(e);
        }
    }

    const onSymbolDensityChange = function (e) {
        if (props.onSymbolDensityChange) {
            props.onSymbolDensityChange(e);
        }
    }

    const onFormatChange = (format) => {
        if (props.onFormatChange) {
            props.onFormatChange(format)
        }
    }

    return <>
        <Accordion.Item eventKey='9'>
            <Accordion.Header><i className="fi-settings me-2" /> Settings</Accordion.Header>
            <Accordion.Body>
                <Form.Group controlId='input-small' className='mb-5'>
                    <Form.Label className='text-body fs-sm me-0 pe-1 text-nowrap'>
                        Snapping tolerance
                    </Form.Label>
                    <ReactSlider className='range-slider range-slider-single' thumbClassName='range-slider-handle' trackClassName='range-slider-track' min={0} max={10} defaultValue={props.snappingTolerance} ariaLabel={['Handle']} ariaValuetext={state => `Handle value ${state.valueNow}`} step={0.5} onChange={onSnappingToleranceChange} renderThumb={(props, state) => (
                        <div {...props}>
                            <div className='range-slider-tooltip'>{state.valueNow}</div>
                        </div>
                    )}
                    />
                </Form.Group>
                <Form.Group controlId='input-small' className='mb-5'>
                    <Form.Label className='text-body fs-sm me-0 pe-1 text-nowrap'>
                        Arrow scale
                    </Form.Label>
                    <ReactSlider className='range-slider range-slider-single' thumbClassName='range-slider-handle' trackClassName='range-slider-track' min={0.1} max={3} value={props.arrowScale} ariaLabel={['Handle']} ariaValuetext={state => `Handle value ${state.valueNow}`} step={0.1} onChange={onArrowScaleChange} onAfterChange={onAfterArrowScaleChange} renderThumb={(props, state) => (
                        <div {...props}>
                            <div className='range-slider-tooltip'>{state.valueNow}</div>
                        </div>
                    )}
                    />
                </Form.Group>
                <Form.Group controlId='input-small' className='mb-5'>
                    <Form.Label className='text-body fs-sm me-0 pe-1 text-nowrap'>
                        Symbol scale
                    </Form.Label>
                    <ReactSlider className='range-slider range-slider-single' thumbClassName='range-slider-handle' trackClassName='range-slider-track' min={0.1} max={3} defaultValue={props.symbolScale} ariaLabel={['Handle']} ariaValuetext={state => `Handle value ${state.valueNow}`} step={0.1} onChange={onSymbolScaleChange} renderThumb={(props, state) => (
                        <div {...props}>
                            <div className='range-slider-tooltip'>{state.valueNow}</div>
                        </div>
                    )}
                    />
                </Form.Group>
                <Form.Group controlId='input-small' className='mb-5'>
                    <Form.Label className='text-body fs-sm me-0 pe-1 text-nowrap'>
                        Symbol density
                    </Form.Label>
                    <ReactSlider className='range-slider range-slider-single' thumbClassName='range-slider-handle' trackClassName='range-slider-track' min={1} max={20} value={props.symbolDensity} defaultValue={props.symbolDensity} ariaLabel={['Handle']} ariaValuetext={state => `Handle value ${state.valueNow}`} step={1} onChange={onSymbolDensityChange} renderThumb={(props, state) => (
                        <div {...props}>
                            <div className='range-slider-tooltip'>{state.valueNow}</div>
                        </div>
                    )}
                    />
                </Form.Group>

                <Form.Group className='mb-5'>
                    <Form.Check type='switch' id='cpm-drawing-order' className='text-body fs-sm' label='CPM Drawing Order' checked={props.cpmDrawingOrder} onChange={e => props.onCpmDrawingOrderChange(e.target.checked)} />
                </Form.Group>

                <BasemapPicker label="Basemap" value={props.basemap} onChange={onBasemapChange} center={props.center} />
                <BasemapPicker label="Basemap (print)" value={props.printBasemap} onChange={onPrintBasemapChange} center={props.center} />

                <Form.Group className="mb-5">
                    <Form.Label className='text-body fs-sm me-0 pe-1 text-nowrap'>
                        Map output format
                    </Form.Label>
                    <div className="d-flex gap-4">
                        <Form.Check className='text-body fs-sm' type='radio' id='radio-jpg' name='radio' label={enums.MapOutputFormat[0]} defaultChecked checked={ props.mapOutputFormat === enums.MapOutputFormat[0] } onChange={ () => onFormatChange(enums.MapOutputFormat[0]) } />
                        <Form.Check className='text-body fs-sm' type='radio' id='radio-png' name='radio' label={enums.MapOutputFormat[1]} checked={ props.mapOutputFormat === enums.MapOutputFormat[1] } onChange={ () => onFormatChange(enums.MapOutputFormat[1]) } />
                    </div>
                </Form.Group>
                
            </Accordion.Body>
        </Accordion.Item>

        
    </>
}